import React, { ComponentType } from 'react';

import { cn, ClassName } from '../../utils';
import styles from './index.module.scss';


export type ProgressLoaderProps = ClassName & {
    value?: number;
    indeterminate?: boolean;
};

const circumference = 2 * Math.PI * 9;
const loaderStyle = { cx: 12, cy: 12, r: 9, strokeWidth: 2, fill: 'none' };

export const ProgressLoader: ComponentType<ProgressLoaderProps> = ({
    className,
    value,
    indeterminate,
}) => (
    <svg
        className={cn(styles.progressLoader, className)}
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
    >
        <circle stroke='#D8D8D8' {...loaderStyle} />
        <circle
            className={cn(
                styles.progress,
                indeterminate && styles.indeterminate,
            )}
            stroke='#EA4B26'
            strokeDasharray={circumference}
            strokeDashoffset={
                circumference * (indeterminate ? 0.75 : 1 - (value || 0))
            }
            {...loaderStyle}
        />
    </svg>
);
